import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { WhoItsFor } from './components/WhoItsFor';
import { Transformation } from './components/Transformation';
import { Pricing } from './components/Pricing';
import { AddOnServices } from './components/AddOnServices';
import { HowItWorks } from './components/HowItWorks';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <TrustBar />
      <Services />
      <WhyUs />
      <WhoItsFor />
      <Transformation />
      <Pricing />
      <AddOnServices />
      <HowItWorks />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}